import React from 'react';
import PropTypes from 'prop-types';

import FavoriteWidget from './parts/FavoriteWidget';

import classes from './FavoritePanel.module.scss';

const FavoritePanel = ({ dataFavorite1, dataFavorite2 }) => {
  return (
    <div className={classes.favoritePanel}>
      <FavoriteWidget dataFavorite={dataFavorite1} mode={'maxAudience'} />
      <FavoriteWidget dataFavorite={dataFavorite2} mode={'maxViews'} />
    </div>
  );
};

FavoritePanel.propTypes = {
  dataFavorite1: PropTypes.array,
  dataFavorite2: PropTypes.array
};

export default FavoritePanel;
